import { c as _c } from "react/compiler-runtime";
import DataRow from './DataRow';
import { useIsPivot, useRows } from './utils/TableStore';
function RowList() {
  const $ = _c(7);
  const pivot = useIsPivot();
  const rows = useRows();
  let t0;
  if ($[0] !== pivot || $[1] !== rows) {
    let t1;
    if ($[3] !== pivot) {
      t1 = (id, i) => <DataRow key={id} rowId={id} pivot={pivot} index={i} />;
      $[3] = pivot;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = rows.map(t1);
    $[0] = pivot;
    $[1] = rows;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[5] !== t0) {
    t1 = <>{t0}</>;
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}
export default RowList;